<app-general-login-flow title="Anmeldung">
  <div class="login-wrapper body">
    <button class="login-btn" [attr.data-testid]="testIds.newLoginBtn" (click)="redirectToLogin()">Anmelden</button>
  </div>
  <div class="login-wrapper body">
    <button class="org-admin" [attr.data-testid]="testIds.orgAdminLoginBtn" (click)="loginViaIDP()">
      Anmelden als Org-Admin
    </button>
  </div>
</app-general-login-flow>
